var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachmentsFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M18.3 75.2V31.5c0-2.1 1.8-3.9 3.9-3.9h35.9c7 0 12.7 5.7 12.8 12.7v2.8h48.8c2.1 0 3.8 1.7 3.8 3.8v63.5c0 2.1-1.7 3.8-3.8 3.8H22.1c-2.1 0-3.8-1.7-3.8-3.8V62.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "DI_4L_main",
    d: "M43.4 40.3l-12 12c-2.6 2.6-2 7.4.6 9.9l.7.7c2.6 2.6 6.9 3.1 10.1.7L58 48.4c1.2-1.2 0-2.6 0-2.6l-5-5c-.7-.7-2-.7-2.7 0L36.2 54.9c-1.1 1.1-1.1 2.8 0 3.8 1.1 1.1 2.8 1.1 3.8 0l11.2-11.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentsFolder);
export default __webpack_public_path__ + "static/media/attachmentsFolder.d5cdeb5c475d007625617ecd72e14f1d.svg";
export { ForwardRef as ReactComponent };